import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { FaCheckCircle, FaStar, FaGem, FaCopy } from "react-icons/fa";
import axios from 'axios';
import { Notify } from 'notiflix';
import { Loading } from 'notiflix';
import { Report } from 'notiflix/build/notiflix-report-aio';


function Premium_content_card() {
    const [mobileNumber, setMobileNumber] = useState("");
    const [Name, setName] = useState('');
    const [screenShotFile, setScreenShotFile] = useState(null);
    const [Error, setError] = useState("");
    const [copiedText, setCopiedText] = useState("");

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        setCopiedText(text);
        Notify.success(`${text} copied to clipboard`);
        setTimeout(() => setCopiedText(""), 1500);
    };

    const HandleSubmit = () => {
        if (!/^\d{10}$/.test(mobileNumber)) {
            setError("Mobile number must be exactly 10 digits.");
            return;
        }
        if (!Name) {
            setError('Name is required');
            return;
        }
        if (!screenShotFile) {
            setError("Please upload a screenshot of your payment.");
            return;
        }

        setError("");
        Loading.dots();

        const formData = new FormData();
        formData.append('screenshot', screenShotFile);
        formData.append('mobile_number', mobileNumber);
        formData.append('Name', Name);

        axios.post('https://kovaikongunadumatrimony.com/kkm_admin/public/api/upload-screen-shot', formData, {
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then(response => {
                const { status, message } = response.data;

                Loading.remove();
                if (status === true) {
                    Notify.success(message);
                    Report.success(
                        'Success',
                        `${message}<br/><br/>We will verify and update the payment shortly. For any further queries, feel free to contact us at <strong>9952676737</strong>.`,
                        'Okay'
                    );

                    // WhatsApp message to admin
                    const whatsappMessage = `
📢 *Payment Intimation*

Hello Admin, I have just completed a payment. Kindly verify the details below:

👤 Name: ${Name}
📱 Mobile Number: ${mobileNumber}

Thank you!
`;
                    const encodedMessage = encodeURIComponent(whatsappMessage);
                    const phoneNumber = "9952676737";
                    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
                    window.open(whatsappURL, "_blank");

                } else {
                    Notify.failure(message || "Something went wrong.");
                }
            })
            .catch(() => {
                Loading.remove();
                Notify.failure("Error while uploading. Please try again.");
            });
    };

    return (
        <>
            <div className="premium-banner">
                <div className="premium-card-container">
                    <Link to="/premiumplans" className="premium-card">
                        <h3 className="premium-card-title">Premium Plan</h3>
                        <div className="decorative-icon-card">
                            <FaGem className="decorative-star" />
                        </div>
                        <ul className="premium-card-text">
                            <li><FaCheckCircle className="icon" /> ₹2000 Rupees Per Year</li>
                            <li><FaCheckCircle className="icon" /> Unlimited Profiles</li>
                            <li><FaCheckCircle className="icon" /> 100 Contacts Per Year</li>
                            <li><FaCheckCircle className="icon" /> 5 Contacts View Per Day</li>
                        </ul>
                        <button className="premium-btn">Purchase This Plan</button>
                    </Link>
                </div>

                <div className="extra-benefits">
                    <h3>Why Go Premium?</h3>
                    <ul>
                        <li><FaStar className="icon" /> Verified & Genuine Profiles</li>
                        <li><FaStar className="icon" /> Priority Customer Support</li>
                        <li><FaStar className="icon" /> Higher Matchmaking Accuracy</li>
                        <li><FaStar className="icon" /> Save Unlimited Favourites</li>
                    </ul>
                    <p className="offer-text">Limited Time Offer - Lock your plan today!</p>
                    <p className="callenquiry">Call for Enquiry: 9952676737</p>
                </div>
            </div>

            {/* Payment Section */}
            <div className="premium-banner py-5 bg-light">
                <div className="container">
                    <div className="row justify-content-center align-items-center">

                        {/* QR Code Section */}
                        <div className="col-md-4 text-center mb-4">
                            <div className="bg-white p-4 rounded shadow-sm">
                                <img
                                    src="https://kovaikongunadumatrimony.com/kkm_images/payment_QR/qr.jpeg"
                                    className="img-fluid mb-3"
                                    alt="QR Code"
                                />
                                <p className="text-muted small mb-3">
                                    Scan this QR code to complete your payment
                                </p>

                                {/* UPI and GPay with Copy */}
                                <div className="bg-light rounded p-3 text-start small">
                                    <div className="mb-2 d-flex justify-content-between align-items-center">
                                        <span><strong>UPI ID:</strong> kovaikongunadumatrimony@okicici</span>
                                        <button
                                            type="button"
                                            style={{ color: 'gray' }}
                                            className="btn btn-sm btn-outline-secondary"
                                            onClick={() => copyToClipboard("kovaikongunadumatrimony@okicici")}
                                        >
                                            {copiedText === "kovaikongunadumatrimony@okicici" ? "Copied" : <FaCopy />}
                                        </button>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center">
                                        <span><strong>GPay:</strong> 9952676737</span>
                                        <button
                                            type="btn"
                                            style={{ color: 'gray' }}
                                            className="btn btn-sm btn-outline-secondary"
                                            onClick={() => copyToClipboard("9952676737")}
                                        >
                                            {copiedText === "9952676737" ? "Copied" : <FaCopy />}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Payment Verification Form */}
                        <div className="col-md-6">
                            <div className="extra-benefits p-4 rounded shadow-sm border">
                                <h3 className="mb-4 premium-card-title fw-bold text-center">Verify Your Payment</h3>

                                <ul className="list-unstyled mb-4">
                                    <li className="d-flex align-items-center mb-2">
                                        <FaStar className="text-warning me-2" />
                                        <span>After completing the payment, upload the screenshot below</span>
                                    </li>
                                </ul>

                                <form>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label fw-bold">Name</label>
                                        <input
                                            type="text"
                                            value={Name}
                                            onChange={(e) => setName(e.target.value)}
                                            id="name"
                                            className="form-control"
                                            placeholder="Enter your Name"
                                        />
                                        {Error && <p className='mb-0 text-danger'>{Error}</p>}
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="mobileNumber" className="form-label fw-bold">Mobile Number</label>
                                        <input
                                            type="text"
                                            value={mobileNumber}
                                            onChange={(e) => setMobileNumber(e.target.value)}
                                            id="mobileNumber"
                                            className="form-control"
                                            placeholder="Enter your mobile number"
                                        />
                                        {Error && <p className='mb-0 text-danger'>{Error}</p>}
                                    </div>

                                    <div className="mb-4">
                                        <label htmlFor="paymentScreenshot" className="form-label fw-bold">Upload Screenshot</label>
                                        <input
                                            type="file"
                                            id="paymentScreenshot"
                                            className="form-control"
                                            onChange={(e) => setScreenShotFile(e.target.files[0])}
                                        />
                                    </div>

                                    <button
                                        type="button"
                                        onClick={HandleSubmit}
                                        className="btn w-100 fw-bold hover-shadow d-block"
                                        style={{ backgroundColor: 'brown', color: 'white' }}
                                    >
                                        Submit
                                    </button>
                                </form>

                                <p className="mt-4 text-center text-muted small">
                                    For assistance, call: <a href="tel:9952676737" className="text-decoration-none">9952676737</a>
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default Premium_content_card;
